import React from 'react';
import { Award, GraduationCap, Heart } from 'lucide-react';
export function PhysicianProfileWoodhouse() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-[#f8faff] dark:from-[#0a0e17] dark:to-[#111827]" data-id="element-990">
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6" data-id="element-991">
        <div className="container mx-auto max-w-6xl" data-id="element-992">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-993">
            {/* Image */}
            <div className="flex justify-center" data-id="element-994">
              <div className="relative" data-id="element-995">
                <div className="absolute inset-0 bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-2xl blur-2xl opacity-20" data-id="element-996"></div>
                <img src="https://cdn.magicpatterns.com/uploads/pJGpHng42ZSUPPRLCduN4V/headshot_CW_3.jpg" alt="Dr. Cristina Woodhouse" className="relative rounded-2xl shadow-2xl w-full max-w-md" data-id="element-997" />
              </div>
            </div>

            {/* Info */}
            <div data-id="element-998">
              <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-999">
                <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-1000">
                  Dr. Cristina Woodhouse, MD, MPH
                </span>
              </h1>
              <p className="text-xl text-gray-600 dark:text-gray-300 mb-6" data-id="element-1001">
                Board Certified Family Medicine Physician
              </p>
              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400 mb-8" data-id="element-1002">
                <Heart className="text-[#C85A15]" size={20} data-id="element-1003" />
                <span data-id="element-1004">Dedicated to patient-centered, collaborative care</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section className="py-16 px-6" data-id="element-1005">
        <div className="container mx-auto max-w-4xl" data-id="element-1006">
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-1007">
            <div className="flex items-center gap-3 mb-6" data-id="element-1008">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-1009">
                <Heart className="text-[#C85A15]" size={24} data-id="element-1010" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-1011">About Dr. Woodhouse</h2>
            </div>
            <div className="space-y-4 text-gray-600 dark:text-gray-300 text-lg leading-relaxed" data-id="element-1012">
              <p data-id="element-1013">
                Cristina Woodhouse, MD is a board-certified family medicine
                physician who has been practicing since 2019. She completed her
                medical studies and master of public health degree at the
                University of Iowa and her family medicine residency at the
                Genesis-Quad Cities Family Medicine Residency Program, also in
                Iowa.
              </p>
              <p data-id="element-1014">
                She enjoys helping patients navigate the complicated world of
                healthcare and the human body. She makes it a priority to listen
                to each patient and answer patient questions thoroughly. She
                also aims to collaborate with each patient to find the option
                that not only works with their physical concerns but also their
                priorities, goals, and lifestyle.
              </p>
              <p data-id="element-1015">
                In her free time she loves to travel, be in nature, and do
                Zumba. She also runs a small nonprofit organization providing
                health education in Honduras and is the mom of a rambunctious
                toddler!
              </p>
            </div>
          </div>

          {/* Education & Training */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-1016">
            <div className="flex items-center gap-3 mb-8" data-id="element-1017">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-1018">
                <GraduationCap className="text-[#BBDDFF]" size={24} data-id="element-1019" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-1020">Education & Training</h2>
            </div>
            <div className="space-y-4" data-id="element-1021">
              <div className="flex items-start gap-3" data-id="element-1022">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-1023" />
                <div data-id="element-1024">
                  <h3 className="font-semibold mb-1" data-id="element-1025">
                    Medical Degree & Master of Public Health
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-1026">
                    University of Iowa
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-1027">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-1028" />
                <div data-id="element-1029">
                  <h3 className="font-semibold mb-1" data-id="element-1030">
                    Family Medicine Residency
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-1031">
                    Genesis-Quad Cities Family Medicine Residency Program, Iowa
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-1032">
                <Award className="text-[#C85A15] flex-shrink-0 mt-1" size={20} data-id="element-1033" />
                <div data-id="element-1034">
                  <h3 className="font-semibold mb-1" data-id="element-1035">Board Certified</h3>
                  <p className="text-gray-600 dark:text-gray-300" data-id="element-1036">
                    Family Medicine
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Philosophy of Care */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-1037">
            <div className="flex items-center gap-3 mb-8" data-id="element-1038">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center" data-id="element-1039">
                <Heart className="text-[#BBDDFF]" size={24} data-id="element-1040" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-1041">Philosophy of Care</h2>
            </div>
            <div className="space-y-4" data-id="element-1042">
              <div className="flex items-center gap-3" data-id="element-1043">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-1044"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-1045">
                  <span className="font-semibold" data-id="element-1046">
                    Patient-Centered Listening
                  </span>{' '}
                  – Prioritizes listening to each patient and answering
                  questions thoroughly
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-1047">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-1048"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-1049">
                  <span className="font-semibold" data-id="element-1050">Collaborative Approach</span>{' '}
                  – Works with patients to find solutions that align with their
                  priorities, goals, and lifestyle
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-1051">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-1052"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-1053">
                  <span className="font-semibold" data-id="element-1054">Holistic Care</span> –
                  Addresses both physical concerns and overall well-being
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-1055">
                <div className="w-2 h-2 rounded-full bg-[#C85A15]" data-id="element-1056"></div>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-1057">
                  <span className="font-semibold" data-id="element-1058">Global Health Advocate</span>{' '}
                  – Runs nonprofit organization providing health education in
                  Honduras
                </p>
              </div>
            </div>
          </div>

          {/* Licensed States */}
          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30 mt-8" data-id="element-1059">
            <div className="flex items-center gap-3 mb-8" data-id="element-1060">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center" data-id="element-1061">
                <Award className="text-[#C85A15]" size={24} data-id="element-1062" />
              </div>
              <h2 className="text-3xl font-bold" data-id="element-1063">Licensed in 8 States</h2>
            </div>
            <div className="flex flex-wrap gap-3" data-id="element-1064">
              {['IA', 'FL', 'IL', 'TX', 'NY', 'MN', 'ID', 'MT'].map(state => <span key={state} className="bg-gradient-to-r from-[#BBDDFF]/20 to-[#C85A15]/20 px-4 py-2 rounded-full font-semibold" data-id="element-1065">
                  {state}
                </span>)}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6" data-id="element-1066">
        <div className="container mx-auto max-w-4xl text-center" data-id="element-1067">
          <div className="bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 rounded-2xl p-12 border border-white/20 dark:border-gray-700/30" data-id="element-1068">
            <h2 className="text-3xl font-bold mb-4" data-id="element-1069">
              Ready to Start Your Journey?
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8" data-id="element-1070">
              Dr. Woodhouse is here to support you with personalized care
              tailored to your needs.
            </p>
            <a href="https://app.joinomu.com/patient/onboarding" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-gradient-to-r from-[#C85A15] to-[#FF8A3D] text-white font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all" data-id="element-1071">
              Get Started Today
            </a>
          </div>
        </div>
      </section>
    </div>;
}